import qs from 'querystring'

import { request } from '@pb/utils'

import { ConfiguredOffers, Offer } from './types'

const fetchConfiguredOffers = async (): Promise<ConfiguredOffers[]> => {
  const { data } = await request.get('member/configuredOffers', {
    type: 'adobe',
  })
  return data
}

const fetchMemberOffers = async (params): Promise<ConfiguredOffers[]> => {
  const { data } = await request.get('member/memberOffers', {
    type: 'adobe',
    query: `?offerKeys=${params}`,
  })
  return data
}

const fetchOffersPropositions = async (): Promise<Offer[]> => {
  const { data } = await request.get('offersProposition')
  return data
}

const fetchRewardDetail = (path): any =>
  request.get(`${path}.hm.json`, {
    use: { apiVersion: false, locale: false },
  })

// Use offer in store
const redeemOffer = (data): Promise<any> =>
  request
    .post('loyalty/redeemOffer', {
      headers: {
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      data: qs.stringify(data),
      use: {
        apiVersion: false,
      },
    })
    .then((res) => res)

export default {
  fetchConfiguredOffers,
  fetchMemberOffers,
  fetchOffersPropositions,
  fetchRewardDetail,
  redeemOffer,
}
